import React from 'react'

//Trainers
import daniel from '../../images/trainers/Daniel1.jpg'
import david from '../../images/trainers/David Pinto.jpg'
import jose from '../../images/trainers/Jose Ojeda.jpg'
import ruben from '../../images/trainers/Ruben Herrera.jpg'

//Rules
import filosofia from '../../images/rules/Filosofia.pdf'
import normas from '../../images/rules/NORMA Y REGLAMENTOS EIDEFUT.pdf'
import sugerencias from '../../images/rules/SUGERENCIAS PARA PADRES Y MADRES.pdf'

//Collaborators logos
import reyHielo from '../../images/collaborators/Cooperativa El Rey del Hielo.jpg'
import norte from '../../images/collaborators/Cooperativa Norte.jpg'
import progreso from '../../images/collaborators/HIELO PROGRESO.png'
import imdenagua from '../../images/collaborators/IMDENAGUA3.jpg'
import firmo from '../../images/collaborators/COMERCIAL FIRMO.png'


const About = () => {

    return (
      <React.Fragment>
        <h1>Acerca de Eidefut</h1>
          <div className="row">
          <div className="col-12 col-lg-6">
              <h3>Normas</h3>
              <div className="row">
                <div className="col-12 block">
                  <iframe className="pdf-rules" frameBorder="0" title='Normas' src={normas}> </iframe>
                   <a className="noColor" target="_blank"  rel="noopener noreferrer" 
                  href={normas} download='Normas de Eidefut'> <b>Normas de Eidefut</b></a><br/> 
                </div>
                <div className="col-12 block">
                  <iframe className="pdf-rules" frameBorder="0" title='Sugerencias' src={sugerencias}> </iframe>
                  <a className="noColor" target="_blank"  rel="noopener noreferrer" 
                  href={sugerencias} download='Sugerencias para representantes'>
                  <b>Sugerencias para representantes</b></a><br/> 
                </div>
                <div className="col-12 block">
                  <iframe className="pdf-rules" frameBorder="0" title='Normas' src={normas}> </iframe>
                   <a className="noColor" target="_blank"  rel="noopener noreferrer" 
                  href={filosofia} download='Filosofía de Eidefut'> <b>Filosofía de Eidefut</b></a><br/>
                </div>
                 
                </div>
            </div>
            <div className="col-12 col-lg-6 category-block">
              <h3>Categorías</h3>
              <article className="eidefut-vision text-left categories-list">
                <ol className="">
                  <li>Sub 6: 4 y 5 años</li>
                  <li>Sub 8: 6 y 7 años</li>
                  <li>Sub 10: 8 y 9 años</li>
                  <li>Sub 12: 10 y 11 años</li>
                  <li>Sub 14: 12 y 13 años</li>
                  <li>Sub 16: 14 y 15 años</li>
                  <li>Sub 18: 16 y 17 años</li>
                  <li>Sub 20: 18 y 19 años</li>
                </ol>
              </article>
            </div>
            <div className="col-sm-12 px-4">
             <h3>Horarios</h3>
             <table>
               <thead>
                <tr>
                  <td>Hora</td>
                  <td>Lunes</td>
                  <td>Martes</td>
                  <td>Miércoles</td>
                  <td>Jueves</td>
                  <td>Viernes</td>
                  <td>Sábado</td>
                  <td>Domingo</td>
                </tr>
               </thead>
               <tbody>
                  <tr>
                    <td>Variable</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>Extras</td>
                    <td>Extras</td>
                  </tr>
                  <tr>
                    <td>2:00 - 3:30</td>
                    <td>Sub10 / Sub12</td>
                    <td>Sub14</td>
                    <td>Sub10 / Sub12</td>
                    <td>Sub14</td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>3:45 - 5:00</td>
                    <td>Sub6 / Sub8</td>
                    <td>Sub16 / Sub18</td>
                    <td>Sub6 / Sub8</td>
                    <td>Sub16 / Sub18</td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
               </tbody>
              </table>
              <div className="schedule-list">
                <article>
                  <ol className="">
                    <li>Lunes: Sub 10 y Sub 12 2:00 pm a 3:30 pm<br/>Sub 6 y Sub 8 de 3:45 pm a 5:00 pm</li>
                    <li>Martes: Sub 14 de 2:00 pm a 3:30 pm <br/>Sub 16 y Sub 18 de 3:45 pm a 5:00 pm</li>
                    <li>Miércoles: Sub 10 y Sub 12 2:00 pm a 3:30 pm<br/>Sub 6 y Sub 8 de 3:45 pm a 5:00 pm</li>
                    <li>Jueves: Sub 14 de 2:00 pm a 3:30 pm <br/>Sub 16 y Sub 18 de 3:35 pm a 5:00 pm</li>
                    <li>Sábado y domingo: Entrenamientos extras, amistosos, clínicas, entre otros.</li>
                  </ol>
                </article>
              </div>
            </div>
          </div>
            <div>
          <div className="my-4">
          <h3 className="mb-4">Entrenadores</h3>
          <div className="row">
            <div className="col-6 col-lg-3">
              <img src={daniel} className="trainer-img" alt="Daniel Herrera"/>
              <h5 className="text-center">Daniel Herrera</h5>
            </div>
            <div className="col-6 col-lg-3">
              <img src={david} className="trainer-img" alt="David Pinto"/>
              <h5 className="text-center">David Pinto</h5>
            </div>
            <div className="col-6 col-lg-3">
              <img src={jose} className="trainer-img" alt="José Ojeda"/>
              <h5 className="text-center">José Ojeda</h5>
            </div>
            <div className="col-6 col-lg-3">
              <img src={ruben} className="trainer-img" alt="Rubén Herrera"/>
              <h5 className="text-center">Rubén Herrera</h5>
            </div>
            
          </div>
        </div>
          <div className="my-4">
              <h3>Colaboradores</h3>
              <div className="row">
                <div className="col-12 col-lg-6">
                    <img src={reyHielo} className="collaborator-img mb-2" alt="El Rey del Hielo"/>
                    <h5 className="text-center">Cooperativa El Rey del Hielo</h5>  
                </div>
                <div className="col-12 col-lg-6">
                    <img src={norte} className="collaborator-img mb-2" alt="Cooperativa Norte"/>
                    <h5 className="text-center">Cooperativa Norte</h5>  
                </div>
                <div className="col-12 col-lg-4">
                    <img src={progreso} className="collaborator-img mb-2" alt="Hielo Progreso"/>
                    <h5 className="text-center">Hielo Progreso</h5>  
                </div> 
                <div className="col-12 col-lg-4">
                    <img src={imdenagua} className="collaborator-img mb-2" alt="Imdenagua"/>
                    <h5 className="text-center">Imdenagua</h5>  
                </div>
                <div className="col-12 col-lg-4">
                    <img src={firmo} className="collaborator-img mb-2" alt="Comercial Firmo"/>
                    <h5 className="text-center">Comercial Firmo</h5>  
                </div>
              </div>
            </div>
          </div>
      </React.Fragment>
       
        );
      }
export default About;